import { CheckCircleOutlined, CloseCircleOutlined, ZoomInOutlined } from '@ant-design/icons';
import { Table, Tooltip, Typography } from "antd";
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { getResource } from '../../../helpers/ResourcesHelper';
import { Beneficiary } from '../../models/Beneficiary';
import DownloadTableRows from '../../shared/DownloadTableRows';

const PendingBeneficiariesTable = (props: any) => {

  const columns: ColumnsType<Beneficiary> = [
    {
      title: getResource('Js_TH_Name'),
      dataIndex: 'BeneficiaryName',
      key: 'bene_BeneficiaryName',
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.BeneficiaryName.localeCompare(b.BeneficiaryName)
    },
    {
      title: getResource('Js_TH_Country'),
      dataIndex: 'CountryName',
      key: 'bene_CountryName',
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.CountryName.localeCompare(b.CountryName)
    },
    {
      title: getResource('Table_TH_RegisterBy'),
      dataIndex: 'RegisterByInfo',
      key: 'bene_RegisterByInfo',
      align: 'center',
      defaultSortOrder: 'descend',
      width: '35%',
      sorter: (a, b) => a.RegisterByInfo.localeCompare(b.RegisterByInfo)
    },
    {
      title: getResource('Table_TH_Actions'),
      dataIndex: 'actions',
      key: 'actions',
      align: 'left',
      width: '15%',
      render: (value: any, obj: any, index: any) => (
        <>
          <Tooltip title={getResource('Js_Link_ViewBeneficiary')}>
            <Typography.Link
              className="column-actions"
              onClick={() => {
                props.onShowBeneinfo(obj)
              }}
            >
              <ZoomInOutlined />
            </Typography.Link>
          </Tooltip>
          <Tooltip title={getResource('Js_Message_Approve')}>
            <Typography.Link
              className="column-actions"
              onClick={() => {
                props.onShowApprovalAlert(obj)
              }}
            >
              <CheckCircleOutlined />
            </Typography.Link>
          </Tooltip>
          <Tooltip title={getResource('Js_Message_Reject')}>
            <Typography.Link
              className="column-actions"
              onClick={() => {
                props.onShowRejectlAlert(obj);
              }}
            >
              <CloseCircleOutlined />
            </Typography.Link>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <React.Fragment>
      <div className="row-actions-1">
        <DownloadTableRows data={props.benes} fileName={'pendingBeneficiaries'} />
      </div>
      <Table
        className=""
        key={'pending-benes-table'}
        columns={columns}
        dataSource={props.benes}
      />
    </React.Fragment>
  );

}

export default PendingBeneficiariesTable;